"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleModelModel = void 0;
exports.GoogleModelModel = {
    Gemini20FlashExp: "gemini-2.0-flash-exp",
    Gemini20FlashRealtimeExp: "gemini-2.0-flash-realtime-exp",
    Gemini15Flash: "gemini-1.5-flash",
    Gemini15Flash002: "gemini-1.5-flash-002",
    Gemini15Pro: "gemini-1.5-pro",
    Gemini15Pro002: "gemini-1.5-pro-002",
    Gemini10Pro: "gemini-1.0-pro",
};
